export function HideOnScroll(elScroll, elHide, HideOnScrollTop = true) {
  elScroll.setAttribute("preScroll", elScroll.scrollTop);
  let Display = elHide.style.display;
  elScroll.onscroll = () => {
    if (HideOnScrollTop) {
      if (elScroll.scrollTop > +elScroll.getAttribute("preScroll"))
        elHide.style.display = "none";
      else elHide.style.display = Display;
    } else {
      if (elScroll.scrollTop < +elScroll.getAttribute("preScroll"))
        elHide.style.display = "none";
      else elHide.style.display = Display;
    }
    elScroll.setAttribute("preScroll", elScroll.scrollTop);
  };
}

export function ScrollTo(element, scrollTo = undefined, anmaition = true) {
  if (scrollTo == undefined) scrollTo = document.querySelector(".page").scrollTop;
  if (anmaition) {

    let Interval = setInterval(() => {
      scrollTo += 3;
      if (
        scrollTo >=
        element.offsetTop - 45
      ) {
        clearInterval(Interval);
        return;
      }
      document.querySelector(".page").scrollTo(0, scrollTo);
    }, 1);
  }else{
    document.querySelector(".page").scrollTo(0, element.offsetTop - 45);

  }
}
